import { Component, Input } from "@angular/core";
import { Actionnaire } from "../../../interfaces/Actionnaire";

@Component({
  selector: "app-representant",
  templateUrl: "./representant.component.html",
  standalone: false,
})
export class RepresentantComponent {
  @Input() actionnaire: Actionnaire;
}
